import { render } from "./ModulInfoText1Spaltig.vue?vue&type=template&id=1a369319"
import script from "./ModulInfoText1Spaltig.vue?vue&type=script&lang=js"
export * from "./ModulInfoText1Spaltig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__